<template>
  <div>
    <sidebar />
    <div class="relative md:ml-64">
      <admin-navbar />
      <header-stats />
      <div class="px-4 md:px-10 mx-auto h-full w-full -m-24">
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>
/* 
  Class: Admin
  Description: This class summarizes all components for admin stuff.
*/

/* Imports */
import AdminNavbar from "@/components/Navbars/AdminNavbar.vue";
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import HeaderStats from "@/components/Headers/HeaderStats.vue";
/* /Imports/ */

export default {
  /* 
    Define different components for reusability. 
  */
  components: {
    AdminNavbar,
    Sidebar,
    HeaderStats,
  }
};
</script>
